<!-- 产品-设备唤醒状态 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="max-width: 1000px;">
            <!-- 表单-输入栏-查询类型 {uid: 查询UID, mac: 查询MAC} -->
            <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
              <md-field>
                <md-select v-model="searchForm.searchType" >
                  <md-option value="srv_ip">{{$I18n('srv_ip')}}</md-option>
                  <md-option value="uid">{{$I18n('dev_uid')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 表单-输入栏-查询参数 (与 searchType 对应) -->
            <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label v-if="searchForm.searchType === 'srv_ip'">{{$I18n('srv_ip')}}</label>
                <label v-if="searchForm.searchType === 'uid'">{{$I18n('dev_uid')}}</label>
                <md-input v-model="searchForm.searchValue"/>
              </md-field>
            </div>
            <!-- 表单-选择栏-设备状态 {0: 全部, 1: 未激活, 2: 已激活} -->
            <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("state")}}</label>
                <md-select v-model="searchForm.state">
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option value="1">{{$I18n('standby')}}</md-option>
                  <md-option value="2">{{$I18n('dev_state_0')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
            <div class="md-layout-item md-size-20 left-layout-item" :style="{'padding-right':0}">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>{{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-内容表格 
            "id": 1,  // ID
            "uid": "umfred000001", // UID
            "mac": "um-fr-ed-00-00-01", // MAC
            "srv_ip": "123.207.88.138", // 服务器
            "sys": "umeye",//服务体系
            "state": 1,//状态，1：待机，2：离线
            "ip": "113.119.134.231",// IP
            "zone": "CN", // 区域
            "gmt_update": 1658383854, // 更新时间
            "gmt_create": 1658311427// 创建时间
           -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
              <md-table-cell :md-label="'MAC'">{{ item.mac }}</md-table-cell>
              <md-table-cell :md-label="$I18n('srv_ip')">{{ item.srv_ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('ser_sys')">{{ item.sys }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.dev_state }}</md-table-cell>
              <md-table-cell :md-label="'IP'">{{ item.ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('zone')">{{ item.zone_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('fri_active_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('last_online_time')">{{ item.update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
  </div>
</template>
<script>
import { timestampToString } from "@/common/tools.js";

export default {
  props: ["userinfo_sys"],
  data() {
    return {
      searchForm : { // 表单-表单数据
        searchType : "uid",
        searchValue: "",
        state : "0",
      },
      searchData : { // 表格-检索数据
        srv_ip : "",
        uids : [],
        state: 0,
      },
      icon  : "computer", // ICON
      title : this.$I18n("device_awake"), // 卡片标题
      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  computed: {
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 状态
          let dev_state = "";//this.$I18n('unknown')
          switch(item.state){
            case "1":
            case 1:
              dev_state = this.$I18n("standby");
              break;
            case "2":
            case 2:
              dev_state = this.$I18n("dev_state_0");
              break;
            case "0":
            case 0:
            default:
              dev_state = this.$I18n("is_active");
              break;
          }
          // 区域名称
          let zone_name = this.$I18n("unknow");
          if (item.zone){
            zone_name = this.$I18n(item.zone);
          }
          return {
            update_time: timestampToString(item.gmt_update * 1000),
            create_time: timestampToString(item.gmt_create * 1000),
            dev_state,
            zone_name,
            ... item,
          }
        })
      }
    },
  },
  methods: {
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getWolState({ // api: /iot/uid/reg/query
          ...this.searchData,
          sys: this.userinfo_sys,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data.map(item => {
            if(!item.ver){
              item.ver = "";
            }
            return item;
          })
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        srv_ip : this.searchForm.searchType === "srv_ip" ?this.searchForm.searchValue :"",
        uids :( this.searchForm.searchType === "uid" && this.searchForm.searchValue !== "") ?[this.searchForm.searchValue] :[],
        sys  : this.userinfo_sys,
        state: parseInt(this.searchForm.state),
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
